"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Keys = exports.Signing = exports.Encryption = void 0;
var crypto = __importStar(require("crypto"));
//browserCrypto will be false for both node AND IE11 AND Advancial because they are destroying window.crypto contents
var browserCrypto = (typeof window === "undefined" || !((_a = window.crypto) === null || _a === void 0 ? void 0 : _a.subtle)) ? false : window.crypto;
var WebConversions = /** @class */ (function () {
    function WebConversions() {
    }
    WebConversions.arrayBufferToBase64 = function (arrayBuffer) {
        var binary = "";
        var bytes = new Uint8Array(arrayBuffer);
        for (var i = 0; i < bytes.byteLength; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    };
    WebConversions.base64ToArrayBuffer = function (b64string) {
        var binaryString = window.atob(b64string);
        var bytes = new Uint8Array(binaryString.length);
        for (var i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    };
    WebConversions.stringToArrayBuffer = function (string) {
        if (window.TextEncoder) {
            return new TextEncoder().encode(string);
        }
        var utf8String = unescape(encodeURIComponent(string));
        var result = new Uint8Array(utf8String.length);
        for (var i = 0; i < utf8String.length; i++) {
            result[i] = utf8String.charCodeAt(i);
        }
        return result;
    };
    return WebConversions;
}());
var Encryption = /** @class */ (function () {
    function Encryption() {
    }
    Encryption.encryptRequest = function (key, body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.encryptAES256(key, JSON.stringify(body))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Encryption.encryptAES256 = function (b64Key, clearText) {
        return __awaiter(this, void 0, void 0, function () {
            var binaryEncryptionKey, IV, bufferJSON, encryptor, encryptedJSON, newBody, iv, encryptionKey, encryptedKey, newBody;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!browserCrypto) return [3 /*break*/, 1];
                        binaryEncryptionKey = Buffer.alloc(32);
                        binaryEncryptionKey.write(b64Key, "base64");
                        IV = crypto.randomBytes(16);
                        bufferJSON = Buffer.from(clearText, "utf8");
                        encryptor = crypto.createCipheriv("aes-256-cbc", binaryEncryptionKey, IV);
                        encryptedJSON = Buffer.concat([encryptor.update(bufferJSON), encryptor.final()]);
                        newBody = {
                            "encrypted_body": encryptedJSON.toString("base64") + "$" + IV.toString("base64")
                        };
                        return [2 /*return*/, newBody];
                    case 1:
                        iv = new Uint8Array(16);
                        browserCrypto.getRandomValues(iv);
                        return [4 /*yield*/, browserCrypto.subtle.importKey("raw", WebConversions.base64ToArrayBuffer(b64Key), "AES-CBC", false, // Not extractable
                            ["encrypt"])];
                    case 2:
                        encryptionKey = _a.sent();
                        return [4 /*yield*/, browserCrypto.subtle.encrypt({
                                name: "AES-CBC",
                                iv: iv
                            }, encryptionKey, WebConversions.stringToArrayBuffer(clearText))];
                    case 3:
                        encryptedKey = _a.sent();
                        newBody = {
                            "encrypted_body": WebConversions.arrayBufferToBase64(encryptedKey) + "$" + WebConversions.arrayBufferToBase64(iv)
                        };
                        return [2 /*return*/, newBody];
                }
            });
        });
    };
    Encryption.encryptSafeKeys = function (headers, b64Key) {
        var _this = this;
        var safe_key_headers = ["x-cardsavr-new-cardholder-safe-key", "x-cardsavr-cardholder-safe-key"];
        safe_key_headers.forEach(function (safe_key_header) { return __awaiter(_this, void 0, void 0, function () {
            var encryptedObj;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!headers[safe_key_header]) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.encryptAES256(b64Key, headers[safe_key_header])];
                    case 1:
                        encryptedObj = _a.sent();
                        headers[safe_key_header] = encryptedObj.encrypted_body;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    Encryption.decryptResponse = function (key, body) {
        return __awaiter(this, void 0, void 0, function () {
            var stringParts, req;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        //handle bodies that don't have an encrypted_body property
                        if (!body || !Object.prototype.hasOwnProperty.call(body, "encrypted_body")) {
                            return [2 /*return*/, body];
                        }
                        stringParts = body.encrypted_body.split("$");
                        if (stringParts[1].length != 24) {
                            // Not a proper 16-byte base64-encoded IV
                            throw new Error("Response body is not properly encrypted.");
                        }
                        req = this.decryptAES256(stringParts[0], stringParts[1], key);
                        return [4 /*yield*/, req];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Encryption.decryptAES256 = function (b64cipherText, b64IV, b64Key) {
        return __awaiter(this, void 0, void 0, function () {
            var binaryEncryptionKey, n, l, equalsIndex, length_1, bodyBuffer, iv, decryptor, decryptedJSON, decryptedString, decryptKey, clearTextBuffer, clearText;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!browserCrypto) return [3 /*break*/, 1];
                        binaryEncryptionKey = Buffer.alloc(32);
                        binaryEncryptionKey.write(b64Key, "base64");
                        n = b64cipherText.length;
                        l = (n / 4) * 3;
                        equalsIndex = b64cipherText.indexOf("=");
                        length_1 = equalsIndex > -1 ? l - (b64cipherText.length - equalsIndex) : l;
                        bodyBuffer = Buffer.alloc(length_1);
                        bodyBuffer.write(b64cipherText, "base64");
                        iv = Buffer.from(b64IV, "base64");
                        decryptor = crypto.createDecipheriv("aes-256-cbc", binaryEncryptionKey, iv);
                        decryptedJSON = Buffer.concat([decryptor.update(bodyBuffer), decryptor.final()]);
                        decryptedString = decryptedJSON.toString("utf8");
                        return [2 /*return*/, JSON.parse(decryptedString)];
                    case 1: return [4 /*yield*/, browserCrypto.subtle.importKey("raw", WebConversions.base64ToArrayBuffer(b64Key), "AES-CBC", false, ["decrypt"])];
                    case 2:
                        decryptKey = _a.sent();
                        return [4 /*yield*/, browserCrypto.subtle.decrypt({
                                name: "AES-CBC",
                                iv: WebConversions.base64ToArrayBuffer(b64IV)
                            }, decryptKey, WebConversions.base64ToArrayBuffer(b64cipherText))];
                    case 3:
                        clearTextBuffer = _a.sent();
                        clearText = new TextDecoder().decode(clearTextBuffer);
                        return [2 /*return*/, JSON.parse(clearText)];
                }
            });
        });
    };
    return Encryption;
}());
exports.Encryption = Encryption;
var Signing = /** @class */ (function () {
    function Signing() {
    }
    Signing.sha256Hash = function (inputString) {
        return __awaiter(this, void 0, void 0, function () {
            var hashMethods;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!browserCrypto) return [3 /*break*/, 1];
                        hashMethods = crypto.createHash("sha256");
                        hashMethods.update(inputString);
                        return [2 /*return*/, hashMethods.digest()];
                    case 1: return [4 /*yield*/, browserCrypto.subtle.digest("SHA-256", WebConversions.stringToArrayBuffer(inputString))];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Signing.signRequest = function (path, appName, sessionKey, body) {
        return __awaiter(this, void 0, void 0, function () {
            var date, nonce, authorization, stringToSign, signature;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        date = new Date();
                        nonce = date.getTime().toString(10);
                        authorization = "SWCH-HMAC-SHA256 Credentials=" + appName;
                        stringToSign = decodeURIComponent(path) + authorization + nonce + (body ? JSON.stringify(body) : "");
                        return [4 /*yield*/, this.hmacSign(stringToSign, sessionKey)];
                    case 1:
                        signature = _a.sent();
                        return [2 /*return*/, {
                                "x-cardsavr-authorization": authorization,
                                "x-cardsavr-nonce": nonce,
                                "x-cardsavr-signature": signature
                            }];
                }
            });
        });
    };
    Signing.verifySignature = function (headers, path, appName, keys, body) {
        return __awaiter(this, void 0, void 0, function () {
            var authorization, nonce, signature, stringToSign, _i, keys_1, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        authorization = headers["x-cardsavr-authorization"];
                        if ("SWCH-HMAC-SHA256 Credentials=" + appName !== authorization) {
                            throw new Error("Authorization header not passed properly, should be: \"SWCH-HMAC-SHA256 Credentials=".concat(appName, "\" not \"").concat(authorization, "\""));
                        }
                        nonce = headers["x-cardsavr-nonce"];
                        if (!nonce) {
                            throw new Error("No nonce header provided.");
                        }
                        signature = headers["x-cardsavr-signature"];
                        if (!signature) {
                            throw new Error("No signature header provided.");
                        }
                        stringToSign = decodeURIComponent(path) + authorization + nonce + (body ? JSON.stringify(body) : "");
                        _i = 0, keys_1 = keys;
                        _a.label = 1;
                    case 1:
                        if (!(_i < keys_1.length)) return [3 /*break*/, 4];
                        key = keys_1[_i];
                        return [4 /*yield*/, Signing.hmacSign(stringToSign, key)];
                    case 2:
                        if ((_a.sent()) === signature) {
                            return [2 /*return*/, true];
                        }
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: throw new Error("Invalid signature.");
                }
            });
        });
    };
    Signing.signSaltWithPasswordKey = function (sessionSalt, passwordKey) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.hmacSign(sessionSalt, passwordKey, true)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Signing.hmacSign = function (inputString_1, b64Key_1) {
        return __awaiter(this, arguments, void 0, function (inputString, b64Key, b64InputString) {
            var stringToSign, binaryKey, hmac, stringToSign, signingKey, signature;
            if (b64InputString === void 0) { b64InputString = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!browserCrypto) return [3 /*break*/, 1];
                        stringToSign = void 0;
                        if (b64InputString) {
                            stringToSign = Buffer.alloc(32);
                            stringToSign.write(inputString, "base64");
                        }
                        else {
                            stringToSign = inputString;
                        }
                        binaryKey = Buffer.alloc(32);
                        binaryKey.write(b64Key, "base64");
                        hmac = crypto.createHmac("sha256", binaryKey);
                        hmac.update(stringToSign);
                        return [2 /*return*/, hmac.digest("base64")];
                    case 1:
                        stringToSign = b64InputString ? WebConversions.base64ToArrayBuffer(inputString) : WebConversions.stringToArrayBuffer(inputString);
                        return [4 /*yield*/, browserCrypto.subtle.importKey("raw", WebConversions.base64ToArrayBuffer(b64Key), {
                                "name": "HMAC",
                                hash: {
                                    name: "SHA-256"
                                },
                            }, false, ["sign"])];
                    case 2:
                        signingKey = _a.sent();
                        return [4 /*yield*/, browserCrypto.subtle.sign("HMAC", signingKey, stringToSign)];
                    case 3:
                        signature = _a.sent();
                        return [2 /*return*/, WebConversions.arrayBufferToBase64(signature)];
                }
            });
        });
    };
    return Signing;
}());
exports.Signing = Signing;
var Keys = /** @class */ (function () {
    function Keys() {
    }
    Keys.generatePasswordKey = function (username, clearTextPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var salt, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Signing.sha256Hash(username)];
                    case 1:
                        salt = _a.sent();
                        return [4 /*yield*/, this.sha256pbkdf2(clearTextPassword, salt, 5000)];
                    case 2:
                        key = _a.sent();
                        return [2 /*return*/, !browserCrypto ? key.toString("base64") : WebConversions.arrayBufferToBase64(key)];
                }
            });
        });
    };
    Keys.generateCardholderSafeKey = function (username) {
        return __awaiter(this, void 0, void 0, function () {
            var saltedCardholderSafeKey, binaryCardholderSafeKey, baseKey, aesKey, rawKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!browserCrypto) return [3 /*break*/, 1];
                        saltedCardholderSafeKey = crypto.pbkdf2Sync(crypto.randomBytes(32), username, 5000, 32, "sha256");
                        return [2 /*return*/, saltedCardholderSafeKey.toString("base64")];
                    case 1:
                        binaryCardholderSafeKey = new Uint8Array(32);
                        browserCrypto.getRandomValues(binaryCardholderSafeKey);
                        return [4 /*yield*/, browserCrypto.subtle.importKey("raw", binaryCardholderSafeKey, "PBKDF2", false, ["deriveBits", "deriveKey"])];
                    case 2:
                        baseKey = _a.sent();
                        return [4 /*yield*/, browserCrypto.subtle.deriveKey({
                                "name": "PBKDF2",
                                "salt": WebConversions.stringToArrayBuffer(username),
                                "iterations": 5000,
                                "hash": "SHA-256"
                            }, baseKey, {
                                "name": "AES-CBC",
                                "length": 256
                            }, true, ["encrypt", "decrypt"])];
                    case 3:
                        aesKey = _a.sent();
                        return [4 /*yield*/, browserCrypto.subtle.exportKey("raw", aesKey)];
                    case 4:
                        rawKey = _a.sent();
                        return [2 /*return*/, WebConversions.arrayBufferToBase64(rawKey)];
                }
            });
        });
    };
    Keys.makeECDHkeyPair = function () {
        return __awaiter(this, void 0, void 0, function () {
            var keyPair;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!browserCrypto) return [3 /*break*/, 1];
                        keyPair = crypto.createECDH("prime256v1");
                        keyPair.generateKeys();
                        return [2 /*return*/, keyPair];
                    case 1: return [4 /*yield*/, browserCrypto.subtle.generateKey({
                            name: "ECDH",
                            namedCurve: "P-256"
                        }, true, ["deriveKey", "deriveBits"])];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Keys.makeECDHPublicKey = function (myKeyPair) {
        return __awaiter(this, void 0, void 0, function () {
            var publicKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!browserCrypto) return [3 /*break*/, 1];
                        return [2 /*return*/, myKeyPair.getPublicKey("base64", "uncompressed")];
                    case 1: return [4 /*yield*/, browserCrypto.subtle.exportKey("raw", myKeyPair.publicKey)];
                    case 2:
                        publicKey = _a.sent();
                        return [2 /*return*/, WebConversions.arrayBufferToBase64(publicKey)];
                }
            });
        });
    };
    Keys.makeECDHSecretKey = function (b64serverPublicKey, myKeyPair) {
        return __awaiter(this, void 0, void 0, function () {
            var key, importedServerKey, binaryPublicKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!browserCrypto) return [3 /*break*/, 1];
                        return [2 /*return*/, myKeyPair.computeSecret(b64serverPublicKey, "base64", "base64")];
                    case 1:
                        key = WebConversions.base64ToArrayBuffer(b64serverPublicKey);
                        return [4 /*yield*/, browserCrypto.subtle.importKey("raw", key, {
                                name: "ECDH",
                                namedCurve: "P-256"
                            }, true, [])];
                    case 2:
                        importedServerKey = _a.sent();
                        return [4 /*yield*/, browserCrypto.subtle.deriveBits({
                                name: "ECDH",
                                public: importedServerKey
                            }, myKeyPair.privateKey, 256)];
                    case 3:
                        binaryPublicKey = _a.sent();
                        return [2 /*return*/, WebConversions.arrayBufferToBase64(binaryPublicKey)];
                }
            });
        });
    };
    Keys.sha256pbkdf2 = function (clearTextPassword, salt, rounds) {
        return __awaiter(this, void 0, void 0, function () {
            var baseKey, aesKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!browserCrypto) return [3 /*break*/, 1];
                        return [2 /*return*/, crypto.pbkdf2Sync(clearTextPassword, salt, rounds, 32, "sha256")];
                    case 1: return [4 /*yield*/, browserCrypto.subtle.importKey("raw", WebConversions.stringToArrayBuffer(clearTextPassword), "PBKDF2", false, ["deriveBits", "deriveKey"])];
                    case 2:
                        baseKey = _a.sent();
                        return [4 /*yield*/, browserCrypto.subtle.deriveKey({
                                "name": "PBKDF2",
                                "salt": salt,
                                "iterations": rounds,
                                "hash": "SHA-256"
                            }, baseKey, {
                                "name": "AES-CBC",
                                "length": 256
                            }, true, ["encrypt", "decrypt"])];
                    case 3:
                        aesKey = _a.sent();
                        return [4 /*yield*/, browserCrypto.subtle.exportKey("raw", aesKey)];
                    case 4: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return Keys;
}());
exports.Keys = Keys;
//# sourceMappingURL=CardsavrSessionCrypto.js.map